import { SystemField } from "./system-field";

export class CurrencyExchangeRate extends SystemField{ 
    from_currency_id?:string;
    to_currency_id?:string;
    method?:string;
    rate?:number;

    //formula fields
    created_by?:string;
    updated_by?:string;
}